function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    initCartDragScroll();
    initCartWishlistButtons();
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      if(cart_count>0){
      	if ($('.cart-sidebar .cart-bubble').length) {
          $('.cart-sidebar .cart-bubble').html('(' + cart_count + ')');
        }

        // All other bubbles → normal count
        $('.cart-bubble').not('.cart-sidebar .cart-bubble').html(cart_count);
        $('.cart-bubble').addClass('active');
      }else{
        $('.cart-bubble').html('');
        $('.cart-bubble').removeClass('active');      	
      }
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
$(document).on('click','.item-remove',function (e) {
  e.preventDefault();
  let data_line = $(this).data('line');
  removeItem(data_line,0);
});
$(document).on('click','.cart-drawer-close,.h_carturl',function (e) {
  e.preventDefault();
  $('body').toggleClass('open-drawer');
});
$(document).on('click','.overlay-box',function (e) {
  $('body').removeClass('open-drawer');
});
$(document).on('click','.ci_plus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal)) {
    $qty.val(currentVal+1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_plus').data('line');
    removeItem(data_line,input_qty);
  }
});
$(document).on('click','.ci_minus a', function (e) {
  e.preventDefault();
  var $qty = $(this).closest('.ci_qtybox').find(".cart_qty");
  var currentVal = parseInt($qty.val(), 10);
  if (!isNaN(currentVal) && currentVal > 1) {
    $qty.val(currentVal - 1);
    var input_qty = $qty.val();
    var data_line = $(this).closest('.ci_minus').data('line');
    removeItem(data_line,input_qty);
  }
});

/*
 * The cart drawer is re-rendered on every cart change, so the Swym wishlist buttons
 * inside it have to be (re-)initialised each time.
 */
var swymCartCallbackQueued = false;
function initCartWishlistButtons() {
  const container = document.querySelector('.cart-sidebar');
  if (!container || !container.querySelector('.swym-button')) return;

  const init = function (swat) {
    if (swat && typeof swat.initializeActionButtons === 'function') {
      swat.initializeActionButtons('.cart-sidebar');
    }
  };

  if (window._swat && window._swat.initializeActionButtons) {
    init(window._swat);
  } else if (!swymCartCallbackQueued) {
    swymCartCallbackQueued = true;
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      swymCartCallbackQueued = false;
      init(swat);
    });
  }
}
// Swym only knows which products are wishlisted once its collections are in.
document.addEventListener('swym:collections-loaded', initCartWishlistButtons);

function initCartDragScroll() {
  const slider = document.querySelector('.cart_pro_list');
  if (!slider) return;
  
  // Check if there's more than one item
  const items = slider.querySelectorAll('.cart_pro_column');
  if (items.length <= 1) return;
  
  // Only enable on desktop (>991px)
  if (window.innerWidth <= 991) return;

  // Prevent dragging images/links (re-run for products swapped in by <cart-upsell>)
  slider.querySelectorAll('a, img').forEach(link => {
    link.addEventListener('dragstart', (e) => e.preventDefault());
  });

  // The slider level listeners only ever need binding once per rendered list
  if (slider.dataset.dragInit === 'true') return;
  slider.dataset.dragInit = 'true';

  let isDown = false;
  let startX;
  let scrollLeft;
  let hasMoved = false;
  
  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    hasMoved = false;
    slider.style.cursor = 'grabbing';
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    e.preventDefault(); // Prevent default drag behavior on links/images
  });
  
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });
  
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.style.cursor = 'grab';
  });
  
  slider.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    hasMoved = true;
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
  
  // Prevent click on links when dragging
  slider.addEventListener('click', (e) => {
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
}
// Initialize on page load if cart is already open
if (document.querySelector('.cart_pro_list')) {
  initCartDragScroll();
}